import { render } from "./maaltijd-step.vue?vue&type=template&id=609e5a81"
import script from "./maaltijd-step.vue?vue&type=script&lang=js"
export * from "./maaltijd-step.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__